import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import '@questlabs/react-sdk/dist/style.css';
import Layout from './components/layout/Layout';
import Landing from './pages/Landing';
import Dashboard from './pages/Dashboard';
import Builder from './pages/Builder';
import Product from './pages/Product';
import Solutions from './pages/Solutions';
import Pricing from './pages/Pricing';
import Signup from './pages/Signup';
import Onboarding from './pages/Onboarding';
import BookDemo from './pages/BookDemo';
import Marketplace from './pages/Marketplace';
import Compliance from './pages/Compliance';
import Docs from './pages/Docs';
import Changelog from './pages/Changelog';
import Legal from './pages/Legal';
import NotFound from './pages/NotFound';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Layout><Landing /></Layout>} />
        <Route path="/product" element={<Layout><Product /></Layout>} />
        <Route path="/solutions" element={<Layout><Solutions /></Layout>} />
        <Route path="/pricing" element={<Layout><Pricing /></Layout>} />
        <Route path="/docs" element={<Layout><Docs /></Layout>} />
        <Route path="/changelog" element={<Layout><Changelog /></Layout>} />
        <Route path="/book-demo" element={<Layout><BookDemo /></Layout>} />
        <Route path="/legal" element={<Layout><Legal /></Layout>} />
        <Route path="/signup" element={<Signup />} />
        <Route path="/onboarding" element={<Onboarding />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/builder" element={<Builder />} />
        <Route path="/marketplace" element={<Layout><Marketplace /></Layout>} />
        <Route path="/compliance" element={<Layout><Compliance /></Layout>} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Router>
  );
}

export default App;